import React from 'react'
import {
  Button,
  Card,
  Grid,
  Image,
} from 'semantic-ui-react'
import Lipstick from '../../../images/mixed.content.lipstick.png'
import Eyebrow from '../../../images/mixed.content.eyebrow.png'
import Makeup from '../../../images/mixed.content.makeup.png'

const lipStickData = {
  type: 'mixed',
  mergeTags: [{
    name: 'Price',
    value: '{{price}}'
  }],
  'value': [
    {
      'type': 'image',
      'value': {
        'alt': 'Cream',
        'href': 'http://www.google.com/',
        'src': 'https://d1oco4z2z1fhwp.cloudfront.net/templates/default/7036/hand_cream.png',
      }
    }, {
      'type': 'title',
      'value': {
        'text': 'Customer Choice',
        'title': 'h1',
      }
    }, {
      'type': 'paragraph',
      'value': {
        'html': 'Consectetuer adipiscing elit. Aenean commodo ligula eget dolor.'
      }
    }, {
      'type': 'paragraph',
      'value': {
        'html': '<span style="font-size: 17px; line-height: 30px;" data-mce-style="font-size: 17px; line-height: 30px;"><span style="text-decoration: line-through; line-height: 21px;" data-mce-style="text-decoration: line-through; line-height: 21px;"><span style="font-size: 16px; line-height: 28px;" data-mce-style="font-size: 16px; line-height: 28px;">75€</span></span> <span style="font-size: 24px; color: #e57965; line-height: 43px;" data-mce-style="font-size: 24px; color: #e57965; line-height: 43px;">{{price}}</span></span>'
      }
    }, {
      'type': 'button',
      'value': {
        'label': 'Buy Now!',
      }
    }
  ]
}

const PromoAddon = ({ save, close, args }) => {
  const [type, setType] = React.useState('')

  const onHandleCompleted = (event, choice) => {
    let data = {}
    switch (choice) {
      case 'lipstick':
        data = lipStickData
        break
      default:
        data = lipStickData
    }
    save({ ...data })
  }

  const onHandleSave = (value) => {
    setType(value)
  }

  const onHandleClose = () => {
    close()
  }


  const PromoAddonActions = () => {
    return (
      <div
        className="actions"
        style={{ width: '100%', textAlign: 'right', marginTop: '5px' }}
      >
        <Button onClick={onHandleCompleted} secondary>
          <i className='save icon'></i> Save
        </Button>
        <Button onClick={onHandleClose}>
          <i className="chevron circle right icon"></i> Cancel
        </Button>
      </div>
    )
  }

  return (
    <>
      <div style={{ width: '100%', marginBottom: '25px' }}>
        <div style={{ color: 'black', paddingBottom: '15px' }}>
          Choose a product category from the list
        </div>
        <Grid verticalAlign='middle' textAlign='center' centered columns="equal">
          <Grid.Row>
            <Grid.Column>
              <div className={type === 'lipstick' ? 'cd_highlight' : ''}>
                <Card fluid>
                  <Card.Content style={{ cursor: 'pointer', textAlign: 'center' }} onClick={() => onHandleSave('lipstick')} >
                    <Card.Header>
                      <Image size='small' src={Lipstick} />
                    </Card.Header>
                    <Card.Description>
                      Lips
                    </Card.Description>
                  </Card.Content>
                </Card>
              </div>
            </Grid.Column>
            <Grid.Column>
              <div className={type === 'eyebrow' ? 'cd_highlight' : ''}>
                <Card fluid>
                  <Card.Content style={{ cursor: 'pointer', textAlign: 'center' }} onClick={() => onHandleSave('eyebrow')} >
                    <Card.Header>
                      <Image size='small' src={Eyebrow} />
                    </Card.Header>
                    <Card.Description>
                      Eyes
                    </Card.Description>
                  </Card.Content>
                </Card>
              </div>
            </Grid.Column>
            <Grid.Column>
              <div className={type === 'makeup' ? 'cd_highlight' : ''}>
                <Card fluid>
                  <Card.Content style={{ cursor: 'pointer', textAlign: 'center' }} onClick={() => onHandleSave('makeup')} >
                    <Card.Header>
                      <Image size='small' src={Makeup} />
                    </Card.Header>
                    <Card.Description>
                      Makeup
                    </Card.Description>
                  </Card.Content>
                </Card>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
      <PromoAddonActions />
    </>
  )
}

export default PromoAddon
